import { SVGProps } from 'react';

export function Enterprise(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      {...props}
    >
      <rect
        width='24'
        height='24'
        rx='2'
        fill='#F0F5FF'
      />
      <path
        d='M8.46659 15.9997H6.7666C5.81327 15.9997 5.33325 15.5197 5.33325 14.5663V6.76636C5.33325 5.81302 5.81327 5.33301 6.7666 5.33301H9.63326C10.5866 5.33301 11.0666 5.81302 11.0666 6.76636V7.99967'
        stroke='#4760F6'
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M15.5801 9.61332V17.0533C15.5801 18.1267 15.0468 18.6667 13.9735 18.6667H10.0801C9.00679 18.6667 8.4668 18.1267 8.4668 17.0533V9.61332C8.4668 8.53999 9.00679 8 10.0801 8H13.9735C15.0468 8 15.5801 8.53999 15.5801 9.61332Z'
        stroke='#4760F6'
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12.9333 7.99967V6.76636C12.9333 5.81302 13.4133 5.33301 14.3667 5.33301H17.2333C18.1867 5.33301 18.6667 5.81302 18.6667 6.76636V14.5663C18.6667 15.5197 18.1867 15.9997 17.2333 15.9997H15.58'
        stroke='#4760F6'
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10.6667 11.333H13.3334'
        stroke='#4760F6'
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10.6667 13.333H13.3334'
        stroke='#4760F6'
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12 18.667V16.667'
        stroke='#4760F6'
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
